//External
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter, useRouter } from "next/router"; //Access routing
//Internal
import { Link } from "../../routes"; //Access routing
import SearchBar from "../../components/search-bar";
import {
  getSelectLocationsOptions,
  get_cookie,
  locationOptions,
  remove_cookie,
  set_cookie,
} from "../../utils";
import { strToLowerCase } from "../../utils";
import {
  setShowDocumentHideProfile,
  setShowEditProfileHideShowProfile,
  setShowOtpBlock,
} from "../../store/actions";
import LoginModal from "../modals/loginModal";
import UserAvatar from "../common/UserAvatar";
import homeIconUrl from "../../public/assets/images/mobile-ic/home-ic.svg";
import homeIconUrlActive from "../../public/assets/images/mobile-ic/home-blue-ic.svg";
import searchIconUrl from "../../public/assets/images/mobile-ic/search-ic.svg";
import searchIconUrlActive from "../../public/assets/images/mobile-ic/search-blue-ic.svg";
import tripIconUrl from "../../public/assets/images/mobile-ic/trip-ic.svg";
import tripIconUrlActive from "../../public/assets/images/mobile-ic/trip-blue-ic.svg";
import profileIconUrl from "../../public/assets/images/mobile-ic/profile-ic.svg";
import profileIconUrlActive from "../../public/assets/images/mobile-ic/profile-blue-ic.svg";

/*******************
  @Purpose : used for footer
  @Parameter : {currentLocationId,locations,userInfo,}
  @Author : INIC
  *******************/
function FooterNav({ currentLocationId, locations, userInfo, currentPage }) {
  const dispatch = useDispatch();
  const cityStateSlug = get_cookie("cityStateSlug");
  const router = useRouter();
  const asPath = router.asPath;
  const [showMenu, setShowMenu] = useState(false);
  const [options, setOptions] = useState([]);
  const [defaultOptionValue, setDefaultOptionValue] = useState("0");
  // const scriptContainerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  const { slug } = router.query;
  let slug1 = "ca";
  let slug2 = "los-angeles";
  let slug3 = "rolls-royce";

  if (slug) {
    slug1 = strToLowerCase(slug[0]);
    if (slug[1]) {
      slug2 = strToLowerCase(slug[1]);
    }
    if (slug[2]) {
      slug3 = strToLowerCase(slug[2]);
    }
  }

  useEffect(() => {
    if (window.screen.width < 1024) {
      // device is mobile
      setIsMobile(true);
    } else {
      // device is desktop
      setIsMobile(false);
    }
  }, []);

  /*******************
  @Purpose : React Hook used for set show menu
  @Parameter : {currentLocationId,locations,userInfo,}
  @Author : INIC
  *******************/
  useEffect(() => {
    setShowMenu(false);
    // remove_cookie("swp");
  }, [slug]);

  // useEffect(() => {
  //   if ((currentPage == "brand" ||
  //     currentPage == "category" ||
  //     currentPage == "home") && scriptContainerRef.current && isMobile) {
  //     const script = document.createElement("script");
  //     script.src =
  //       "https://app.newra.ai/chat_widget/newra_widget_init.js?widgetKey=7aa4c013-d53b-46f8-b159-a37f265a5bd4";
  //     script.async = true;

  //     scriptContainerRef.current.appendChild(script);

  //     return () => {
  //       if (
  //         scriptContainerRef.current &&
  //         scriptContainerRef.current.contains(script)
  //       ) {
  //         scriptContainerRef.current.removeChild(script);
  //       }
  //     };
  //   }
  // }, [currentPage, isMobile]);

  /*******************
  @Purpose : React Hook used for set show menu
  @Parameter : {currentLocationId,locations,userInfo,}
  @Author : INIC
  *******************/
  useEffect(() => {
    let tempOptions = locationOptions();
    let tempDefaultOptionValue = "0";
    if (locations && locations.length !== 0) {
      tempOptions = [];
      const selectOptionsObj = getSelectLocationsOptions(
        locations,
        currentLocationId,
        "footer"
      );
      tempDefaultOptionValue = selectOptionsObj.defaultOptionValue;
      tempOptions = selectOptionsObj.options;
      setOptions(tempOptions);
      setDefaultOptionValue(tempDefaultOptionValue);
    }
  }, [locations]);

  /*******************
  @purpose : on location change event
  @Parameter : {slugname}
  @Author : INIC
  ******************/
  const onLocationChange = (slugName) => {
    let path = "";
    if (slugName == "/") {
      path = "/";
    } else {
      path = "/" + slugName;
    }
    set_cookie("redirectUrl", path, 1);
    router.push(path);
  };

  /*******************
  @Purpose : used for home Click redirect
  @Parameter : {}
  @Author : INIC
  *******************/
  const homeClickRedirect = () => {
    const r = get_cookie("redirectUrl");
    if (r) {
      router.push(r);
    } else {
      router.push("/");
    }
  };

  /*******************
  @Purpose : Wishlist handler
  @Parameter : {}
  @Author : INIC
  *******************/
  const wishlistHandler = () => {
    if (userInfo?.id) {
      router.push("/wishlists");
    } else {
      handleShow();
    }
  };

  // Login model
  const [show, setShow] = useState(false);
  const handleShow = () => {
    dispatch(setShowOtpBlock(false));
    setShow(true);
    set_cookie("swp", "yes", 1);
  };
  const handleClose = (rcswp = 0) => {
    if (rcswp) {
      remove_cookie("swp");
    }
    setShow(false);
  };

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <div className="footer-search-bar">
        {showMenu && (
          <SearchBar
            slug1={slug1}
            slug2={slug2}
            currentLocationId={currentLocationId}
            showMenu={showMenu}
            setShowMenu={setShowMenu}
            showAutofocus={true}
          />
        )}
      </div>

      <div className="footer-nav safe-area-bottom">
        <ul className="list-unstyled d-flex mb-0 flex-wrap footer-nav-tab">
          <li
            className={`nav-item ${asPath == "/" || asPath == "/fl/miami" ? "active" : ""
              }`}
          >
            <div className="nav-text ff-hel-med" onClick={homeClickRedirect}>
              <span className="icon  ic-1">
                <img src={homeIconUrl} alt="home"></img>
              </span>
              <span className="icon  ic-2">
                <img src={homeIconUrlActive} alt="home"></img>
              </span>
              Home
            </div>
          </li>

          <li className="nav-item wishlist-ic" onClick={wishlistHandler}>
            <div className="nav-text ff-hel-med">
              <svg
                className={`icon ${asPath == "/wishlists"
                  ? "icon-fill-heart"
                  : "icon-empty-heart"
                  }`}
                viewBox="0 0 32 32"
                aria-hidden="true"
                role="presentation"
                focusable="false"
              >
                <path d="m16 28c7-4.733 14-10 14-17 0-1.792-.683-3.583-2.05-4.95-1.367-1.366-3.158-2.05-4.95-2.05-1.791 0-3.583.684-4.949 2.05l-2.051 2.051-2.05-2.051c-1.367-1.366-3.158-2.05-4.95-2.05-1.791 0-3.583.684-4.949 2.05-1.367 1.367-2.051 3.158-2.051 4.95 0 7 7 12.267 14 17z"></path>
              </svg>
              Wishlists
            </div>
          </li>


          {/* <li className="nav-item">
            <div className="d-flex align-items-center justify-content-end flex-column h-100 select-link">
              <span className="icon loc-ic ic-1">
                <img src={locationIconUrl}></img>
              </span>
              <span className="icon loc-ic ic-2">
                <img src={locationIconUrlActive}></img>
              </span>
              <Select
                instanceId="location"
                menuPlacement="top"
                isSearchable={false}
                value={options[defaultOptionValue]}
                classNamePrefix="custom_link"
                options={options}
                onChange={(e) => {
                  onLocationChange(e.value);
                }}
              />
            </div>
          </li> */}


          <li
            className="nav-item"
            onClick={() => {
              setShowMenu(true);
            }}
          >
            <div className="nav-text ff-hel-med">
              <span className="icon ic-1">
                <img src={searchIconUrl} alt="search"></img>
              </span>
              <span className="icon ic-2">
                <img src={searchIconUrlActive} alt="search"></img>
              </span>
              Search
            </div>
          </li>
          <li className={`nav-item ${asPath == "/my-trips" ? "active" : ""}`}>
            <Link href="/my-trips">
              <a className="nav-text ff-hel-med">
                <span className="icon  ic-1">
                  <img src={tripIconUrl} alt="trips"></img>
                </span>
                <span className="icon  ic-2">
                  <img src={tripIconUrlActive} alt="trips"></img>
                </span>
                Trips
              </a>
            </Link>
          </li>

          <li
            className={`nav-item ${asPath == "/personal-details" ? "active" : ""
              }`}
            onClick={() => {
              dispatch(setShowEditProfileHideShowProfile(true));
              dispatch(setShowDocumentHideProfile(true));
            }}
          >
            {userInfo?.first_name ? (
              <Link href="/personal-details">
                <a className="nav-text ff-hel-med">
                  <span className="icon avatar-icon">
                    <UserAvatar userInfo={userInfo} />
                  </span>
                  Profile
                </a>
              </Link>
            ) : (
              <div
                className="nav-text ff-hel-med"
                onClick={() => router.push("/login")}
              >
                <span className="icon  ic-1">
                  <img src={profileIconUrl} alt="profile"></img>
                </span>
                <span className="icon  ic-2">
                  <img src={profileIconUrlActive} alt="profile"></img>
                </span>
                Log in
              </div>
            )}
          </li>

          {/* {(currentPage == "brand" ||
            currentPage == "category" ||
            currentPage == "home") && (
              <li className="nav-item active">
                {" "}
                <div ref={scriptContainerRef} onClick={() => {
                  const headerElements = document.querySelectorAll(".header");
                  headerElements.forEach((element) => {
                    element.style.zIndex = "";
                  });
                  const footerElements = document.querySelectorAll(".footer-nav");
                  footerElements.forEach((element) => {
                    element.style.zIndex = "";
                  });
                }} className="targetBot"></div>
              </li>
            )} */}
        </ul>
      </div>

      {/* Login modal */}
      <LoginModal show={show} handleClose={handleClose} />
    </>
  );
}

/********************
@purpose : Connect With Redux
@Parameter : {user}
@Author : INIC
******************/
const mapStateToProps = ({ user }) => ({
  userInfo: user?.userInfo,
});
export default withRouter(connect(mapStateToProps)(FooterNav));
